import parseLanguages from "base-shell/lib/utils/locale";
import { lazy } from "react";

import LayoutContainer from "containers/LayoutContainer/LayoutContainer";
import Loading from "../components/Loading/Loading";
import AuthProvider from "../providers/Auth";
import CartProvider from "../providers/Cart";
import OrderProvider from "../providers/Order";
import ShopProvider from "../providers/Shop";
import I18nProvider from "providers/I18nProvider";
import locales from "./locales";
import routes from "./routes";

import { baseRoute, stage } from "./const";

const config = {
  containers: {
    LayoutContainer: ({ children, ...props }) => (
      <LayoutContainer {...props}>
        <AuthProvider>
          <ShopProvider
            mock={stage === "local" ? require("./mock").shop : undefined}
          >
            <I18nProvider>
              <OrderProvider>
                <CartProvider>{children}</CartProvider>
              </OrderProvider>
            </I18nProvider>
          </ShopProvider>
        </AuthProvider>
      </LayoutContainer>
    ),
  },
  components: {
    Loading,
  },
  pwa: {
    useiOSPWAPrompt: true,
    iOSPWAPromptProps: {},
  },
  routes: routes(baseRoute),
  locale: {
    locales,
    defaultLocale: parseLanguages(["zh-tw"], "zh-tw"),
    onError: (e) => {
      // Here we warn the user about translation error
      // console.warn(e)
      return;
    },
  },
  appbar: {
    width: 240,
    isAppBarVisible: true,
    enableMenu: true,
  },
  menu: {
    offlineIndicatorHeight: 12,
    initialAuthMenuOpen: false,
    initialMiniMode: false,
    initialMenuOpen: false,
    initialMobileMenuOpen: false,
    initialMiniSwitchVisibility: true,
    useWindowWatcher: false,
  },
  theme: {
    // themes,
    defaultThemeID: "default",
    defaultIsDarkMode: false,
    defaultIsRTL: false, // change this to true for default Right to Left Language support
  },
  pages: {
    PageNotFound: lazy(() => import("../pages/PageNotFound")),
    LandingPage: lazy(() => import("../pages/LandingPage")),
  },
  notistack: {},
};

export default config;
